import Vue from "vue";
import utils from '../utils'

Vue.filter("localDatetime", (value) => {
    var currentTimezone = (Vue.state.currentTimezone && Vue.state.currentTimezone.get()) || null;
    return utils.formatDateTime(value, "DD/MM/YYYY HH:mm", currentTimezone);
});



// WEBPACK FOOTER //
// ./_common/filters/local-datetime.filter.js